import { Paper, Typography, List, ListItemButton, ListItemText, ListItemIcon, Divider, Box, useTheme, alpha } from "@mui/material";
import TagIcon from '@mui/icons-material/Tag';
import AddIcon from '@mui/icons-material/Add';

import { Topic } from "../api/topics";

type Props = {
    topics: Topic[];
    selectedTopicId: number | null;
    onSelectTopic: (id: number | null) => void;
    onCreateTopic: () => void;
};

export default function TopicSidebar({ topics, selectedTopicId, onSelectTopic, onCreateTopic }: Props) {
    const theme = useTheme();
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, minWidth: 240, maxHeight: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} color="text.secondary" sx={{ mb: 1, px: 1 }}>
        FEEDS
      </Typography>
      <List disablePadding sx={{ overflowY: 'auto' }}>
        <ListItemButton 
            selected={selectedTopicId === null}
            onClick={() => onSelectTopic(null)}
            sx={{ 
                borderRadius: 2, 
                mb: 1,
                bgcolor: selectedTopicId === null ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
                '&.Mui-selected': { bgcolor: alpha(theme.palette.primary.main, 0.15) },
                borderLeft: selectedTopicId === null ? `4px solid ${theme.palette.primary.main}` : '4px solid transparent',
            }}
        >
            <ListItemIcon sx={{ minWidth: 32, zIndex: 1, color: selectedTopicId === null ? 'primary.main' : 'inherit' }}>
                <TagIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText 
                primary="All Posts" 
                primaryTypographyProps={{ 
                    fontWeight: 800,
                    color: selectedTopicId === null ? 'primary.main' : 'text.primary',
                }} 
            />
        </ListItemButton>
        
        <Divider sx={{ my: 1, mx: 1 }} />
        
        {topics.map((topic) => (
             <ListItemButton 
                key={topic.topic_id}
                selected={selectedTopicId === topic.topic_id}
                onClick={() => onSelectTopic(topic.topic_id)}
                sx={{ 
                    borderRadius: 2, 
                    mb: 0.5,
                    bgcolor: selectedTopicId === topic.topic_id ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
                    '&.Mui-selected': { bgcolor: alpha(theme.palette.primary.main, 0.15) },
                    borderLeft: selectedTopicId === topic.topic_id ? `4px solid ${theme.palette.primary.main}` : '4px solid transparent',
                }}
            >
                <ListItemIcon sx={{ minWidth: 32, zIndex: 1, color: selectedTopicId === topic.topic_id ? 'primary.main' : 'inherit' }}>
                    <TagIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText 
                    primary={topic.name} 
                    primaryTypographyProps={{ 
                        fontWeight: selectedTopicId === topic.topic_id ? 700 : 500,
                        color: selectedTopicId === topic.topic_id ? 'primary.main' : 'text.primary',
                    }} 
                />
            </ListItemButton>
        ))}
        
        <Divider sx={{ my: 1 }} />
        
        <ListItemButton 
            onClick={onCreateTopic}
            sx={{ borderRadius: 2, color: 'primary.main' }}
        >
            <ListItemIcon sx={{ minWidth: 32, color: 'inherit' }}>
                <AddIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Create Topic" primaryTypographyProps={{ fontWeight: 600 }} />
        </ListItemButton>
      </List>
    </Paper>
  );
}
